<div class="submit-entry-modal-container">
  <div class="heading-container">
    <div class="pre-text">You have selected</div>
    <div class="main-text mat-headline-4">No change, submit entry</div>
  </div>
  <div class="notes-container">
    <textarea
      [formControl]="notes"
      placeholder="Enter any notes for today's entry..."
    ></textarea>
  </div>
  <div class="button-container">
    <div class="are-you-sure-button">
      <app-link-button color="accent" type="button" (onClick)="close(false)"
        >Cancel entry</app-link-button
      >
    </div>
    <div class="are-you-sure-button">
      <app-action-button
        kind="filled"
        color="primary"
        size="wide"
        (onClick)="close(true)"
        >Save & submit</app-action-button
      >
    </div>
  </div>
</div>
